import React from "react";

const PopUpParagraph = ({ title, paragraph }) => {
  return (
    <div className="pop-up-p">
      <p className="title">{title && title}</p>
      <pre className="paragraph">{paragraph && paragraph}</pre>
    </div>
  );
};

export default PopUpParagraph;
